import {Injectable} from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {IProdGridService} from 'prod-grid';
import {HttpExtraParams, HttpFilterParam} from 'prod-shared';
import {IProdFormService} from 'prod-form';
import {AbstractProdSelectService, IProdSelectProperties} from 'prod-select';
import {IOrganizationTreeSelect} from "../dip/i-organization-tree-select";
import {OrganizationTreeSelect} from "../dip/organization-tree-select";
import {HttpClient} from "@angular/common/http";
import {Car} from "../models/car";

@Injectable({providedIn: 'root'})
export class CarService extends AbstractProdSelectService implements IProdGridService, IProdFormService, IOrganizationTreeSelect {
  override selectDataUrl: string = 'cars';
  override selectProperties: IProdSelectProperties = {
    id: 'id',
    name: 'vin'
  };
  confirmReplaceDongle$: BehaviorSubject<any> = new BehaviorSubject<any>(null);

  constructor(public override httpClient: HttpClient, private organizationTreeSelect: OrganizationTreeSelect) {
    super(httpClient);
  }

  getCar(id) {
    return this.httpClient.get<{ data: Car, success: boolean }>(`/api/car/${id}`, );
  }

  getProdGridData(params?: HttpExtraParams): Observable<Object> {
    return this.httpClient.get<{ data: { result: Car[], totalCount: number }, success: boolean }>(`/api/cars`, {params});
  }

  prodGridAdd(values: any): Observable<Object> {
    return this.httpClient.post(`/api/car`, values);
  }

  prodGridPatch(values: any, id: number): Observable<Object> {
    return this.httpClient.patch(`/api/car/${id}`, values);
  }

  prodGridRemove(id: number): Observable<Object> {
    return this.httpClient.delete(`/api/deleteCar/${id}`);
  }

  moveCars(payload): Observable<Object> {
    return this.httpClient.post(`/api/cars/move`, payload);
  }

  reActivate(id: number) {
    return this.httpClient.post(`/api/car/${id}/reActivate`, {});
  }

  getOrganizationFilter(): HttpFilterParam[] {
    let ids = [];
    ids = ids.concat(this.organizationTreeSelect.ids);
    if (this.organizationTreeSelect.company) {
      ids.push(this.organizationTreeSelect.company.id);
    }

    if (this.organizationTreeSelect.distributor || this.organizationTreeSelect.organizationTreeSelect$.value === -1) {
      if (this.organizationTreeSelect.organizationTreeSelect$.value === -1 || this.organizationTreeSelect.distributor.id === -1) {
        return [
          new HttpFilterParam({
            property: 'equipment.organization.distributor',
            operator: 'isNull',
            value: null
          }),
          new HttpFilterParam({
            property: 'equipment.organization.organization.distributor',
            operator: 'isNull',
            value: null
          })
        ];
      }
      ids = ids.concat(this.organizationTreeSelect.distributor.distributorCompanies.map(company => {
        let ids = company.subOrganizations.map(site => {
          return site.id;
        });

        ids.push(company.id);

        return ids;
      }).flat()).filter(f => f);
    }
    return [new HttpFilterParam({
      property: 'equipment.organization',
      operator: 'in',
      value: ids
    })];
  }
}
